document.addEventListener('DOMContentLoaded', function () {
  var menuButton = document.querySelector('.menu-toggle');
  var nav = document.querySelector('#SiteNav');

  if (menuButton && nav) {
    menuButton.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function setQuantity(input, delta) {
    if (!input) return;
    var value = parseInt(input.value || '1', 10);
    value = Math.max(1, value + delta);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.querySelectorAll('[data-quantity-minus]').forEach(function (button) {
    button.addEventListener('click', function () {
      setQuantity(document.querySelector('#Quantity'), -1);
    });
  });

  document.querySelectorAll('[data-quantity-plus]').forEach(function (button) {
    button.addEventListener('click', function () {
      setQuantity(document.querySelector('#Quantity'), 1);
    });
  });

  document.querySelectorAll('[data-cart-minus],[data-cart-plus]').forEach(function (button) {
    button.addEventListener('click', function () {
      var line = button.getAttribute('data-line');
      var input = button.parentElement ? button.parentElement.querySelector('input[name="updates[]"]') : null;
      var value = parseInt(input && input.value ? input.value : '1', 10);
      if (button.hasAttribute('data-cart-minus')) value = Math.max(0, value - 1);
      if (button.hasAttribute('data-cart-plus')) value = value + 1;
      if (input) input.value = value;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({line: parseInt(line, 10), quantity: value})
      })
      .then(function () { window.location.reload(); })
      .catch(function () {});
    });
  });
});